import { keyframes, styled } from '@mui/material';
import { LoaderCircleIcon } from './icons';

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

// Figma draws the active badge with a static arc; it only reads as in-progress
// once it turns. Not ModLoadingSpinner — that takes an explicit color rather
// than inheriting the badge's currentColor.
export const SpinningLoaderIcon = styled(LoaderCircleIcon)({
  animation: `${spin} 1s linear infinite`,
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none'
  }
});
